export const USES_SERVICE_SPECIFIC_SCOPE = true
